import styled from 'styled-components';

import { LargeLogoSVG } from '../../logos';

const CloseButtonWrapper = styled.div`
  left: ${({ theme }) => theme.spacing(1)};
  position: absolute;
`;

const LogoWrapper = styled.div`
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  display: flex;
  height: 50px;
  justify-content: center;
  padding: 0;
  width: 100%;
`;

const LargeLogo = styled(LargeLogoSVG)`
  width: 150px;
`;

export { CloseButtonWrapper, LogoWrapper, LargeLogo };
